<template>
	<div class="page">
		<div v-if="isPaymentTimeoutError" class="page__error">
			<span class="page__error--text">{{ $t('letbane.payment_timeout') }}</span>
			<button class="page__button reset-button" type="button" @click="routeToFrontPage()">
				{{ $t('letbane.buy_tickets_uppercase') }}
			</button>
		</div>
		<div v-else class="page__error">
			<span class="page__error--text">{{ $t('letbane.ticket_error') }} <br />{{ $t('letbane.we_are_working_on_solution') }}</span>
			<button class="page__button reset-button" type="button" @click="routeToFrontPage()">
				{{ $t('letbane.buy_tickets_uppercase') }}
			</button>
		</div>
	</div>
</template>

<script>
export default {
	computed: {
		isPaymentTimeoutError() {
			return this.$route.query.error === 'paymenttimeout'
		},
	},
	methods: {
		routeToFrontPage() {
			this.$router.push({ path: '/' })
		},
	},
}
</script>

<style lang="scss" scoped>
.page {
	display: flex;
	align-items: center;
	height: 100%;

	&__error {
		display: flex;
		flex-direction: column;
		font-size: 1.625rem;
		line-height: 2rem;
		text-align: center;

		&--text {
			margin-bottom: 3.1875rem;
		}
	}

	&__button {
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 1rem;
		width: 100%;
		height: 47px;
		background-color: $letbane-color-identityred;
		color: $letbane-color-white;
		border-radius: 0.375rem;
		margin-bottom: 0.9375rem;
		cursor: pointer;
		transition: background-color 0.3s ease;

		&:hover {
			background-color: $letbane-color-identityred-hover;
		}

		&:focus {
			background-color: $letbane-color-identityred-pressed;
		}

		&:disabled {
			background-color: $letbane-color-identityred-disabled;
		}
	}
}
</style>